import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Agenda/getTareasDia`, method: 'POST', body: values, token: token})
}
